const DATA_SOURCE_LABELS = {
  postgresql: 'PostgreSQL',
  'live-api': 'Venue Intelligence',
  cache: 'Cache / Demo data',
};

/** Map backend X-Data-Source header value to dashboard label text. */
export function formatDataSourceLabel(dataSource) {
  if (!dataSource) return null;
  const key = String(dataSource).trim().toLowerCase();
  return DATA_SOURCE_LABELS[key] || null;
}
